export default __webpack_public_path__ + "static/media/CSSupervisors.546c452a.png";